/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class FaqService extends __BaseService {
  static readonly getFaqListPath = '/faq';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get List of faq.
   * @param lang Language short code.
   */
  getFaqListResponse(lang?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (lang != null) __params = __params.set('lang', lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/faq`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get List of faq.
   * @param lang Language short code.
   */
  getFaqList(lang?: string): __Observable<null> {
    return this.getFaqListResponse(lang).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module FaqService {
}

export { FaqService }
